exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[dir] .FormContainer{margin-top:6rem}[dir] .createJiraRequest_buttonSpacing__1Z6xy{margin-top:-1rem;margin-bottom:2rem}", ""]);

// Exports
exports.locals = {
	"buttonSpacing": "createJiraRequest_buttonSpacing__1Z6xy"
};